import { Container, Divider, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'
import useAppStore from '../hooks/useAppStore'

interface FooterProps {
  brandName: string
}

const Footer: React.FC<FooterProps> = () => {
  const { logoUrl, brandName } = useAppStore() as { logoUrl: string; brandName: string }
  const currentYear = new Date().getFullYear()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Container maxWidth={'xl'} sx={{ marginTop: 'auto', px: { xs: 2, sm: 3, md: 4 } }}>
      <Grid container columns={12} spacing={{ xs: 2, sm: 3 }} minHeight={6}>
        <Grid item xs={12} padding={0}>
          <Divider />
        </Grid>

        <Grid
          container
          item
          justifyContent={'space-between'}
          paddingBottom={{ xs: 2, md: 3 }}
          spacing={{ xs: 2, sm: 3 }}
        >
          <Grid
            item
            display={'flex'}
            flexDirection={{ xs: 'column', sm: 'row' }}
            gap={{ xs: 1, sm: 2 }}
            xs={12}
            md={6}
            lg={7}
            alignItems={{ xs: 'center', sm: 'center' }}
          >
            <img 
              src={logoUrl} 
              className='logo'
              style={{ maxWidth: isMobile ? '100px' : '150px' }}
            />

            <Typography 
              variant="body2" 
              alignSelf={'center'}
              textAlign={{ xs: 'center', sm: 'left' }}
              sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
            >
              © {currentYear} {brandName} - {isMobile ? '' : 'eine Marke der '}Firstcon GmbH
            </Typography>
          </Grid>

          <Grid 
            item 
            display={'flex'}
            xs={12}
            md={6}
            lg={5}
            justifyContent={{ xs: 'center', md: 'flex-end' }}
          >
            <Typography
              alignSelf={'center'}
              variant="body2"
              sx={{ 
                display: 'flex', 
                gap: { xs: 1.5, sm: 2, md: 3 },
                flexWrap: 'wrap',
                justifyContent: 'center',
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                '& a': {
                  color: 'text.primary',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }
              }}
            >
              <Link to="/helpandcontact">{isMobile ? 'Hilfe' : 'Hilfe & Kontakt'}</Link>
              <Link to="/imprint">Impressum</Link>
              <Link to="https://www.firstcon.de/datenschutz.html" target="_blank">Datenschutz</Link>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Footer
